import actionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../../util/createReducer';
import _ from 'lodash';

const INITIAL_STATE = {
  clientsList: [],
};

const reducer = createReducer(INITIAL_STATE, {
  [actionTypes.CLIENTS_LIST_RESET]: (state: any) => {
    return {
      ...state,
      clientsList: [],
    };
  },
  [actionTypes.CLIENTS_LIST_PUSH]: (state: any, action: any) => {
    return {
      ...state,
      clientsList: [...action.values, ...state.clientsList],
    };
  },
  [actionTypes.CLIENTS_LIST_REMOVE]: (state: any, action: any) => {
    const index = _.indexOf(
      state.clientsList,
      _.find(state.clientsList, { id: action.client.id }),
    );
    if (index >= 0) {
      return {
        ...state,
        clientsList: [
          ...state.clientsList.slice(0, index),
          ...state.clientsList.slice(index + 1),
        ],
      };
    } else {
      return {
        ...state,
      };
    }
  },
  [actionTypes.CLIENTS_LIST_REPLACE]: (state: any, action: any) => {
    const index = _.indexOf(
      state.clientsList,
      _.find(state.clientsList, { id: action.client.id }),
    );
    if (index >= 0) {
      return {
        ...state,
        clientsList: [
          ...state.clientsList.slice(0, index),
          action.client,
          ...state.clientsList.slice(index + 1),
        ],
      };
    } else {
      return {
        ...state,
        clientsList: [...state.clientsList, action.client],
      };
    }
  },
});

export default reducer;
